import axios from 'axios';
import { BASE_API_URL } from '../constants/env';

export const getIssueTypes = async (token, page, size, sortField, filtersData) => {

    const url = sortField ? `${BASE_API_URL}/issue-types/search?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/issue-types/search?page=${page}&size=${size}`;

    return axios.post(url, filtersData, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
        .then((response) => {
            const { data } = response;
            return data;
        }).catch(error => {
            console.log('Error on getIssueTypes call: ', error);
            return error;
        });
}

export const searchIssueTypesByName = async (token, text) => {
    const url = `${BASE_API_URL}/issue-types/list`;

    return axios
        .post(url, text, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on searchIssueTypesByName call: ', error);
            return error;
        });
};

export const getIssueType = async (token, id) => {
    const url = `${BASE_API_URL}/issue-types/${id}`;

    return axios.get(url, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    }
    ).then(response => {
        const { data } = response;
        return data;
    }).catch(error => {
        console.log('Error on getIssueType call: ', error);
        return error;
    })
}

export const createIssueType = async (token, data) => {
    const url = `${BASE_API_URL}/issue-types`;
    const payload = {
        name: data.name,
        description: data.description,
        vehicleRequired: data.vehicleRequired,
        requesterRequired: data.requesterRequired,
    };

    return axios.post(url, payload, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    }).then((response) => {
        return response;
    }).catch(error => {
        console.log('Error on createIssueType call: ', error);
        return error.response;
    });
}

export const editIssueType = async (token, roleId, data) => {
    const url = `${BASE_API_URL}/issue-types/${roleId}`;
    const payload = {
        name: data.name,
        description: data.description,
        vehicleRequired: data.vehicleRequired,
        requesterRequired: data.requesterRequired,
    };

    return axios.put(url, payload, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    }).then((response) => {
        return response;
    }).catch(error => {
        console.log('Error on editIssueType call: ', error);
        return error.response;
    });
}

export const deleteIssueType = async (token, roleId) => {
    const url = `${BASE_API_URL}/issue-types/${roleId}`;

    return axios.delete(url, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    }).then((response) => {
        return response;
    }).catch(error => {
        console.log('Error on deleteIssueType call: ', error);
        return error.response;
    });
}
